import axios from 'axios'
import { errorHandler } from "../exports/error_management"

const api = async(method, path, params) => axios[method](path, params)
const state = {
    selectedType: {},
    types: [],
}

const mutations = {
    SET_SELECTED_TYPE(state, { data, id }) {
        let index = state.types.findIndex(x => x.id === id)
        index = index >= 0 ? index : state.types.length
        if (data) state.types.splice(index, 1, data)
        else state.types.splice(index, 1)
        console.log('checkoff types', state.types)
        state.types.sort((a, b) => {
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
            else if (b.name.toUpperCase() > a.name.toUpperCase()) return -11
            else return 0
        })
        state.selectedType = data || {}
    },
    SET_TYPES(state, payload) {
        state.types = payload
    },
    SET_NULL_TYPE(state) {
        state.selectedType = {}
    },
}

const actions = {
    async fetchAll(context) {
        try {
            const results = await api('get', `checkoff`)
            context.commit('SET_TYPES', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchById(context, id) {
        try {
            const results = await api('get', `checkoff/${id}`)
            const data = results.data.success.data
            context.commit('SET_SELECTED_TYPE', { data, id })
        } catch (err) {
            errorHandler(err)
        }
    },

    async create(context, payload) {
        try {
            const id = null
            const results = await api('post', `checkoff`, payload)
            const data = results.data.success.data
            context.commit('SET_SELECTED_TYPE', { data, id })
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const { id } = payload
            delete payload.id
            const results = await api('put', `checkoff/${id}`, payload)
            const data = results.data.success.data
            context.commit('SET_SELECTED_TYPE', { data, id })
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `checkoff/${id}`)
            const data = null
            context.commit('SET_SELECTED_TYPE', { data, id })
        } catch (err) {
            errorHandler
        }
    },

    ////////////////////////////roles
    async createRole(context, { checkoff_type_id, role_id }) {
        try {
            const results = await api(
                'post',
                `checkoff/${checkoff_type_id}/roles`, { role_id }
            )
            const data = results.data.success.data
            context.commit('SET_SELECTED_TYPE', { data, id: checkoff_type_id })
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteRole(context, { checkoff_type_id, id }) {
        try {
            const results = await api(
                'delete',
                `checkoff/${checkoff_type_id}/roles/${id}`
            )
            const data = results.data.success.data
            context.commit('SET_SELECTED_TYPE', { data, id: checkoff_type_id })
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}